import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { AppState } from '../../../../../../types/store';
import { Url } from '@wix/da-url';
import { PapiUser } from '@wix/da-papi-types';
import { actions as modalActions } from '@wix/da-shared-react/pkg/Modals';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/basicActions';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import { showMobileSharePopup } from '@wix/da-shared-react/pkg/Modals/redux/actionCreators';
import { clickWatch } from '@wix/da-shared-react/pkg/WatchButton/redux/actionCreators';
import {
  requestJoinGroup,
  requestLeaveGroup,
} from '@wix/da-shared-react/pkg/redux/groups/actions';
import {
  getProfileOwner,
  getProfileOwnerUser,
  getIsGroupProfile,
  getProfileOwnerExtendedGroup,
  isCurrentUserProfileOwner,
} from '../../../../../selectors/users';
import {
  fetchProfileOwnerGiveState,
  fetchProfileOwnerGiveStateSuccess,
} from '../../../../../actions/profileOwner';
import { Props } from './MoreActionsDropdownMobile';

type StateProps = Pick<
  Props,
  'giveState' | 'profileOwnerUser' | 'isOwner' | 'isGroup' | 'extendedGroup'
>;
type DispatchProps = Pick<
  Props,
  | 'pushBadgeModal'
  | 'pushPointsModal'
  | 'initGiveState'
  | 'onLlamaBadgeSent'
  | 'onCakeBadgeSent'
  | 'pushBlockModal'
  | 'requestJoinGroup'
  | 'showMobileSharePopup'
  | 'leaveGroup'
  | 'closeGroup'
  | 'unwatch'
>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  giveState: getProfileOwner(state).giveState!,
  profileOwnerUser: getProfileOwnerUser(state),
  isOwner: isCurrentUserProfileOwner(state),
  isGroup: getIsGroupProfile(state),
  extendedGroup: getProfileOwnerExtendedGroup(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  ownProps
) => ({
  pushBadgeModal: (username: string, onBadgeSent?: () => void) =>
    dispatch(modalActions.pushBadgeModal(username, onBadgeSent)),
  pushPointsModal: (userId, title) =>
    dispatch(modalActions.pushPointsModal(userId, title)),
  initGiveState: () => dispatch(fetchProfileOwnerGiveState()),
  onLlamaBadgeSent: () =>
    dispatch(fetchProfileOwnerGiveStateSuccess({ canBeGivenLlama: false })),
  onCakeBadgeSent: () =>
    dispatch(fetchProfileOwnerGiveStateSuccess({ canBeGivenCake: false })),
  requestJoinGroup: (profileOwnerUser: PapiUser) =>
    dispatch(requestJoinGroup(profileOwnerUser)),
  pushBlockModal: (profileOwner: PapiUser) =>
    dispatch(
      pushModal(ModalType.USER_BLOCK, {
        wrapInModal: true,
        params: {
          user: profileOwner,
          redirectLocation: Url.browseHomeLink(),
        },
      })
    ),
  showMobileSharePopup: (url: string, title: string) => {
    dispatch(showMobileSharePopup(url, title));
  },
  leaveGroup: (profileOwner: PapiUser) => {
    dispatch(requestLeaveGroup(profileOwner));
  },
  closeGroup: (group: PapiUser) => {
    dispatch(pushModal(ModalType.GROUP_CLOSE, { params: { group } }));
  },
  unwatch: (profileOwner: PapiUser) => {
    dispatch(clickWatch(profileOwner, true));
  },
});

export default connect(mapStateToProps, mapDispatchToProps);
